import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { FiUser, FiAward, FiBookmark, FiTrendingUp } from 'react-icons/fi';

const Profile = ({ user }) => {
  const [userData, setUserData] = useState({
    completedTopics: [],
    bookmarkedTopics: [],
    quizScores: {},
    totalProgress: 0
  });

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        } else {
          // Initialize user data
          const initialData = {
            completedTopics: [],
            bookmarkedTopics: [],
            quizScores: {},
            totalProgress: 0
          };
          await setDoc(doc(db, 'users', user.uid), initialData);
          setUserData(initialData);
        }
      }
    };

    fetchUserData();
  }, [user]);

  const stats = [
    {
      icon: <FiTrendingUp />,
      label: 'Progress',
      value: `${userData.totalProgress}%`
    },
    {
      icon: <FiAward />,
      label: 'Completed Topics',
      value: userData.completedTopics?.length || 0
    },
    {
      icon: <FiBookmark />,
      label: 'Bookmarked',
      value: userData.bookmarkedTopics?.length || 0
    },
    {
      icon: <FiUser />,
      label: 'Quizzes Taken',
      value: Object.keys(userData.quizScores || {}).length
    }
  ];

  return (
    <div>
      <div className="content-section">
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <div className="user-avatar" style={{ width: '64px', height: '64px', fontSize: '24px' }}>
            {user.email?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div>
            <h1 className="topic-title" style={{ marginBottom: '8px' }}>
              {user.displayName || user.email?.split('@')[0]}
            </h1>
            <p style={{ color: '#757575' }}>{user.email}</p>
          </div>
        </div>
      </div>

      <div className="feature-grid">
        {stats.map((stat, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon" style={{ color: '#4CAF50' }}>{stat.icon}</div>
            <h3 className="feature-title">{stat.value}</h3>
            <p className="feature-description">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="content-section">
        <h2 className="section-title">
          <FiTrendingUp /> Learning Progress
        </h2>
        <div className="progress-tracker">
          <div className="progress-header">
            <span className="progress-title">Overall Progress</span>
            <span className="progress-percentage">{userData.totalProgress}%</span>
          </div>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${userData.totalProgress}%` }}></div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2 className="section-title">
          <FiBookmark /> Bookmarked Topics
        </h2>
        <div className="section-content">
          {userData.bookmarkedTopics && userData.bookmarkedTopics.length > 0 ? (
            <ul>
              {userData.bookmarkedTopics.map((topic, index) => (
                <li key={index}>{topic}</li>
              ))}
            </ul>
          ) : (
            <p>No bookmarked topics yet. Start exploring and bookmark your favorites!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;

